import { RoutesDictionary } from '../dictionaries/routes.dictionary';

export const MAIN_PAGE = RoutesDictionary.ASSIGNMENTS;
export const MODULE_ROOT_PATH = 'jobs-placements';
